import { ConcreteEncodable } from "./ConcreteEncodable";

import { ActivationDetailsImplEncoder } from "../../encoder/ActivationDetailsImplEncoder";

import * as CubiqTS from "../../index";
import { ActivationDetails } from "../ActivationDetails";

export class ActivationDetailsImpl extends ConcreteEncodable implements ActivationDetails {
  public static enType: string = "com.bcdfx.model.ActivationDetailsImpl";

  /*FID=1*/
  public activationDate: string;
  /*FID=2*/
  public activationTime: string;
  /*FID=3*/
  public timezone: string;
  /*FID=4*/
  public timeAlias: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = ActivationDetailsImplEncoder.Instance;
    this.setEncodableType(ActivationDetailsImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "ActivationDetailsImpl[" +
      "activationDate=" +
      this.activationDate +
      "activationTime=" +
      this.activationTime +
      "timezone=" +
      this.timezone +
      "timeAlias=" +
      this.timeAlias +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
